import { getConversationById } from '@app/helpers'
import { isBuyerView } from '@app/utils'

import { ChatState, JoinChatPayload } from '../types'
import { ensureUniqueMessages } from './ensureUniqueMessages'

export const onJoinConversationSuccess = (
  state: ChatState,
  payload: JoinChatPayload
): ChatState => {
  const { acsChatThreadId, id, participants } = payload

  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  const unread = isBuyerView() ? conversation.unread : false

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [payload.id]: {
        ...conversation,
        acsChatThreadId,
        participants,
        updateDate: payload.updateDate,
        joining: 'SUCCEED',
        messages: ensureUniqueMessages([
          ...payload.messages,
          ...conversation.messages,
        ]),
        total: payload.total,
        unread,
      },
    },
  }
}
